import axios from 'axios'
import {get} from 'lodash'

const baseURL = '/api/tour/state/list/'

/**
 * @param {number | Object} init
 * @property {number} id
 * @property {string} state_name
 */
export default class TourStateClass {
	/**
	 * @constructor
	 * @param {Object} init
	 */
	constructor (init = {}) {
		this.id = null
		this.setDefaultData()

		this.setDefaultData(init)
	}

	setDefaultData (init = {}) {
		if (!init) return

		this.id = get(init, 'id') ? init.id : null
		this.state_name = get(init, 'state_name') ? init.state_name : ''

		this.errors = {}
	}

	static url = baseURL
	/**
	 * get all tours state
	 * @param {Object} params
	 * @returns {Promise<{data: TourStateClass[]}>}
	 */
	static getAll (params) {
		return axios.get(baseURL, {
			params
		})
			.then(res => {
				return {
					...res.data,
					data: this.createObjectFromArray(res.data.data)
				}
			})
			.catch(err => {
				console.error(err)
				return null
			})
	}
	static createObjectFromArray (arr) {
		return arr.map(item => new TourStateClass(item))
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/Tour/TourState.class.js